import { Injectable } from "@angular/core";
import { Notice } from '../notice/notice.service';

@Injectable()
export class MessageService {

    messages: string[] = [];
    infoMessages: any[] = [];
    noticeList: Notice[] = [];

    addError(message: string) {
        this.messages.push(message);
    }

    clearError() {
        this.messages = [];
    }

    addNotice(noticeList: Notice[]) {
        this.noticeList = noticeList;
    }

    clearNotice() {
        this.noticeList = [];
    }

    addInfo(message: string) {
        const id = new Date().getTime();
        this.infoMessages.push({id: id, message: message});
        setTimeout(() => {
            this.infoMessages = this.infoMessages.filter(obj => obj.id != id);
        }, 5000);
    }

    clearInfo() {
        this.infoMessages = [];
    }

    clearAll() {
        this.clearError();
        this.clearInfo();
        this.clearNotice();
    }

}



// WEBPACK FOOTER //
// ./src/app/common/message.service.ts